/* eslint-disable camelcase */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-return-assign */
import { format, differenceInYears } from 'date-fns';
import {
  filter, forEach, groupBy, indexOf, pull, reduce, find, includes, isNil,
} from 'lodash-es';

import { EFiltryGlowneInAtrybutyMulti, EFiltryGlowneInAtrybutySingle } from '@/components/filtry/types/EFiltryGlowneInAtrybutyMulti';
import { formatDatyBackend } from '@/terminy.config.js';
import { EShownComponent } from '@/types/EShownComponent';

const mapRequiredLokalizacje_HoteloProdukt = async (Lokalizacje_HoteloProdukt, context) => {
  const hotele = [];

  Lokalizacje_HoteloProdukt.forEach((element) => {
    const findLokalizacja = find(context.state.lokalizacjeFlat, { Wartosc: element });

    findLokalizacja ? context.commit('pushWymaganeFiltry', { key: 'wybraneDokad', item: element }) : hotele.push(element);
  });
  if (!!hotele.length) {
    await context.commit('hoteloProduktFromUrl', hotele);
  }
};

const mapRequiredMiasta = (Miasta, context) => {
  Miasta.forEach((element) => {
    const findMiasto = find(context.state.miastaFlat, { Wartosc: element });

    if (findMiasto) {
      context.commit('pushWymaganeFiltry', { key: 'wybraneSkad', item: element });
    }
  });
};

export const mapRequiredDate = (terminWyjazdu, context) => {
  const arr = [];

  terminWyjazdu.forEach((element) => {
    arr.push(new Date(element));
  });
  context.commit('filtry/data', arr, { root: true });
};

export const setCurrentAdultAge = (currentAdultAge, datyUrodzenia) => {
  const arr = [];

  datyUrodzenia.forEach((item) => {
    differenceInYears(item, new Date()) <= -18 ? arr.push(currentAdultAge) : arr.push(item);
  });
  return arr;
};

export const setDateParams = (searchParams, data) => {
  if (data?.length >= 1) {
    searchParams.set('dataStart', format(data[0], formatDatyBackend));
  }

  if (data?.length >= 2) {
    searchParams.set('dataKoniec', format(data[1], formatDatyBackend));
  }
};

export const mapCleanWybrane = (filters) => filters.reduce((wybrane, filtr) => {
  wybrane[filtr.Wartosc] = filtr.CzyMultiSelect ? [] : {};
  return wybrane;
}, {});
export const parseQueryParams = (state) => {
  const searchParams = new URLSearchParams();

  if (!isNil(state.data)) {
    setDateParams(searchParams, state.data);
  }

  searchParams.set('typTransportu', state.typTransportu);

  forEach(state.wybraneDokad, (element) => {
    searchParams.append('lokalizacje[]', element);
  });

  forEach(state.wybraneSkad, (element) => {
    searchParams.append('miasta[]', element);
  });

  let query = searchParams.toString();

  // eslint-disable-next-line no-return-assign
  return query !== '' ? (query = `?${query}`) : query;
};

export const groupLokalizacjeByType = (lokalizacje) => groupBy(lokalizacje, 'Typ');

export const mapLokalizacjeRelations = (lokalizacjeSource) => {
  const relations = [];
  const lokalizacje = lokalizacjeSource;

  forEach(lokalizacje, (lokalizacja) => {
    if (lokalizacja.Typ === 'kontynent' || lokalizacja.Typ === 'panstwo') {
      lokalizacja.Dzieci = filter(lokalizacje, { WartoscRodzica: lokalizacja.Wartosc });
    }

    if (lokalizacja.Typ === 'kontynent') {
      relations.push(lokalizacja);
    }
  });
  return relations;
};
export const mapMiastaRelations = (lokalizacjeSource) => {
  const relations = [];
  const lokalizacje = lokalizacjeSource;

  forEach(lokalizacje, (lokalizacja) => {
    if (lokalizacja.WartoscRodzica === null && lokalizacja.Wartosc !== 'dowolny') {
      lokalizacja.Dzieci = filter(lokalizacje, { WartoscRodzica: lokalizacja.Wartosc });
      relations.push(lokalizacja);
    }

    if (lokalizacja.WartoscRodzica === null && lokalizacja.Wartosc === 'dowolny') {
      const arr = [];

      forEach(lokalizacje, (item) => {
        if (item.WartoscArr) {
          arr.push(item);
        }
      });
      lokalizacja.Dzieci = arr;
      relations.push(lokalizacja);
    }
  });
  return relations;
};

export const mapPopularneKierunki = (popularne, panstwa) => {
  const arr = [];

  forEach(popularne, (item) => {
    const kierunek = find(panstwa, { Wartosc: item });

    if (kierunek) {
      arr.push(kierunek);
    }
  });

  return arr;
};

export const toggleValueInArray = (array, value) => {
  const isInArray = indexOf(array, value) >= 0;

  if (isInArray) {
    pull(array, value);
  } else {
    array.push(value);
  }

  return isInArray;
};
// targetArray, filtry, payload
export const filterChilds = (params) => {
  const { targetArray, filtry, payload } = params;

  if (!toggleValueInArray(targetArray, payload.value)) return targetArray;

  const filtr = filtry.find((x) => x.Wartosc === payload.name);
  const pole = filtr.Pola ? filtr.Pola.find((x) => x.Wartosc === payload.value) : null;

  if (!pole || !pole.Pola) return targetArray;

  const childs = pole.Pola;

  return targetArray.filter((x) => !childs.find((child) => child.Wartosc === x));
};

export const toggleCheckbox = (parentsArray, kierunek, targetArray) => {
  const parent = find(parentsArray, { Wartosc: kierunek.WartoscRodzica });

  if (parent && targetArray.includes(parent.Wartosc)) {
    // if parent is checked
    forEach(parent.Dzieci, (child) => {
      // check all children but the clicked one
      if (child.Wartosc !== kierunek.Wartosc && child.CzyPokazywac) toggleValueInArray(targetArray, child.Wartosc); // child: true
    });
    toggleValueInArray(targetArray, kierunek.WartoscRodzica); // uncheck the parent: false
  } else {
    toggleValueInArray(targetArray, kierunek.Wartosc); // toggle checkbox: true/false
  }

  if (!parent) {
    // uncheck of children who were chosen before their parents
    forEach(kierunek.Dzieci, (child) => {
      if (includes(targetArray, child.Wartosc)) toggleValueInArray(targetArray, child.Wartosc);
    });
    return;
  }

  if (!parent.WartoscRodzica) {
    return;
  }

  const visibleParentDzieci = parent.Dzieci.filter((child) => child.CzyPokazywac);
  // Check/uncheck children
  const areAllChildrenChecked = reduce(
    visibleParentDzieci,
    (reducer, child) => (reducer = reducer && includes(targetArray, child.Wartosc)),
    true,
  );

  if (!areAllChildrenChecked) {
    return;
  }

  // last child is checked
  forEach(visibleParentDzieci, (child) => {
    // uncheck all unchecked children inside parent, we only need parent checked
    toggleValueInArray(targetArray, child.Wartosc); // child: false
  });
  toggleValueInArray(targetArray, kierunek.WartoscRodzica); // check the parent: true
};

export const mapRequiredFiltryBoczne = (filtryBoczne, context) => {
  filtryBoczne.forEach((element) => {
    const item = find(element.Pola, 'CzyDefault');

    if (item) {
      context.commit('filtryBoczne/changeWybraneValue', { name: element.Wartosc, value: { selected: item.Wartosc } }, { root: true });
    }
  });
};

export const mapRequiredAtrybutyMulti = async (AtrybutyMulti, context) => {
  if (AtrybutyMulti?.Lokalizacje_HoteloProdukt) {
    await mapRequiredLokalizacje_HoteloProdukt(AtrybutyMulti.Lokalizacje_HoteloProdukt, context);
  }

  if (AtrybutyMulti?.Miasta) {
    mapRequiredMiasta(AtrybutyMulti.Miasta, context);
  }

  for (const [key, item] of Object.entries(AtrybutyMulti)) {
    if (key in EFiltryGlowneInAtrybutyMulti) continue;

    item.forEach((element) => {
      if (includes(context.rootState.filtryBoczne.wybrane[key], element)) return;

      const dostepnePola = find(context.rootState.filtryBoczne.filtry, { Wartosc: key });

      if (dostepnePola) {
        const findElement = find(dostepnePola.Pola, { Wartosc: element });

        if (findElement) {
          context.dispatch('filtryBoczne/toggleCheckbox', { name: key, value: element }, { root: true });
        } else {
          dostepnePola?.Pola.forEach((childElement) => {
            if (childElement?.Pola) {
              if (find(childElement.Pola, { Wartosc: element })) {
                context.dispatch('filtryBoczne/toggleCheckbox', { name: key, value: element }, { root: true });
                context.dispatch('filtryBoczne/toggleCheckbox', { name: key, value: childElement.Wartosc }, { root: true });
              }
            }
          });
        }
      }
    });
  }
};
export const mapRequiredAtrybutySingle = (AtrybutySingle, context) => {
  if (AtrybutySingle?.TerminWyjazdu) mapRequiredDate(AtrybutySingle.TerminWyjazdu, context);

  if (AtrybutySingle?.TypTransportu) context.commit('typTransportu', AtrybutySingle.TypTransportu[0]);

  for (const [key, item] of Object.entries(AtrybutySingle)) {
    if (key in EFiltryGlowneInAtrybutySingle) continue;

    // FiltryBoczne
    item.forEach((element) => {
      const dostepnePola = find(context.rootState.filtryBoczne.filtry, { Wartosc: key });

      if (dostepnePola) {
        const findElement = find(dostepnePola.Pola, { Wartosc: element });

        findElement
          ? context.commit('filtryBoczne/changeWybraneValue', { name: key, value: { selected: element } }, { root: true })
          : context.commit('filtryBoczne/changeWybraneValue', { name: key, value: { value: element } }, { root: true });
      }
    });
  }
};

export const mapRequiredDatyUrodzenia = (datyUrodzenia, context) => {
  const arr = [];

  datyUrodzenia.forEach((element) => {
    arr.push(new Date(element));
  });
  context.commit('filtry/datyUrodzenia', arr, { root: true });
};

export const commitRequiredPokoje = (value, context) => {
  context.dispatch('filtry/setLiczbaPokoiFromUrl', parseInt(value, 10), { root: true });
};

export const commitRequiredSortowanie = (value, context) => {
  const findElement = find(context.rootState.szukaj.sortowanie, { Klucz: value });

  if (findElement) context.commit('szukaj/changeSortowanie', findElement, { root: true });
};
export const commitRequiredWidok = (value, context) => {
  if (value === EShownComponent.bloczki || value === EShownComponent.map) {
    context.commit('szukaj/shownComponent', value, { root: true });
  }
};

export const buildFilters = async (filtr, context, fromUrl = false) => {
  if (filtr?.AtrybutyMulti) await mapRequiredAtrybutyMulti(filtr.AtrybutyMulti, context);

  if (filtr?.AtrybutySingle) mapRequiredAtrybutySingle(filtr.AtrybutySingle, context);

  if (filtr?.DatyUrodzenia) mapRequiredDatyUrodzenia(filtr.DatyUrodzenia, context);

  if (filtr?.LiczbaPokoi) commitRequiredPokoje(filtr.LiczbaPokoi, context);

  if (filtr?.Sortowanie) commitRequiredSortowanie(filtr.Sortowanie, context);

  if (fromUrl) {
    if (filtr?.Widok) commitRequiredWidok(filtr.Widok, context);
  }
};
